// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3l7Ly","tab":"Tabs_tab__2SKLG","tabActive":"Tabs_tabActive__2B4-Q"};